import React from "react"
import { useLocation } from "react-router-dom"
import historyStore from "stores/historyStore";

const GTM = process.env.REACT_APP_GTM_CONTAINER

const Tracker = () => {
  const location = useLocation()
  React.useEffect( () => {
    historyStore.fullHistory.push( {
      hash    : location.hash,
      key     : location.key,
      pathname: location.pathname,
      search  : location.search
    } )
    
    if ( typeof window.ga === 'function' ) {
      const page = location.pathname + location.search + location.hash
      if ( GTM ) {
        console.info( `send pageview GTM: ${page}` )
        window.ga( "gtm1.set", 'page', page )
        window.ga( 'gtm1.send', 'pageview' )
      } else {
        console.info( `send pageview: ${page}` )
        window.ga( 'set', 'page', page )
        window.ga( 'send', 'pageview' )
      }
      
    }
  }, [location] )
  return null
  
}


export default Tracker



// WEBPACK FOOTER //
// ./src/components/Tracker/Tracker.js